{
  "name": "Nurlings",
  "bot": {
    "singular": "Nurling",
    "plural": "Nurlings"
  },
  "tagline": "Powered by Nurturist AI",
  "description": "Your team of always-on agents.",
  "company": {
    "name": "Nurturist AI",
    "url": "https://nurturistai.com"
  },
  "urls": {
    "site": "https://nurlings.nurturistai.com",
    "cloud": null,
    "iosApp": null,
    "androidApp": null,
    "community": null
  },
  "native": {
    "bundleId": "com.nurturistai.nurlings"
  },
  "ticketPrefix": "NUR",
  "mark": {
    "viewBox": "237 574 1584.9 898",
    "smallViewBox": "237 574 1369 898",
    "blob": "M1343 1432C1290.7 1425.7 1244.3 1400.3 1210.2 1359.5C1195 1341.4 1188.6 1330.2 1176 1299.5C1158.4 1256.8 1143.6 1232.5 1119 1205.9C1095 1179.9 1053.9 1151.8 1022.2 1139.5C900.4 1092.5 761.5 1135.9 690.7 1243C684.2 1252.8 679 1262.9 662.6 1297.4C642.3 1339.9 613.1 1370.8 573 1392.3C505.4 1428.4 418.2 1421.9 356.7 1376.3C240.1 1289.5 254.6 1114.1 384.1 1045.6C399.8 1037.3 409.9 1033.8 439.5 1026.5C493.8 1013.1 525.5 998.2 561.5 969.3C603 936 634.4 890.9 653.5 837C667.6 797.1 669.5 792.1 675 780C700.1 724.8 746.8 676.4 801.8 648.7C870 614.2 940.4 605.6 1010.9 623.1C1093.5 643.6 1158.7 692.6 1198.8 764.5C1211.6 787.5 1218.5 805.2 1227 838C1243.3 900.2 1267.1 942.2 1308.9 982.2C1340.8 1012.8 1375.2 1032.3 1422 1046.5C1443.7 1053.1 1458.5 1059.4 1472.8 1068.2C1560 1121.5 1591.9 1232.1 1546.5 1323.5C1518.5 1379.8 1465.5 1418.7 1400.5 1430.6C1389.9 1432.5 1354.6 1433.3 1343 1432ZM901.7 802.3L875.8 909.9A32.6 32.6 0 0 0 939.2 925.2L965.2 817.7A32.6 32.6 0 0 0 901.7 802.3ZM1040.8 833.9L1014.7 941.5A32.7 32.7 0 0 0 1078.3 956.9L1104.3 849.3A32.7 32.7 0 0 0 1040.8 833.9Z",
    "blobBody": "M1343 1432C1290.7 1425.7 1244.3 1400.3 1210.2 1359.5C1195 1341.4 1188.6 1330.2 1176 1299.5C1158.4 1256.8 1143.6 1232.5 1119 1205.9C1095 1179.9 1053.9 1151.8 1022.2 1139.5C900.4 1092.5 761.5 1135.9 690.7 1243C684.2 1252.8 679 1262.9 662.6 1297.4C642.3 1339.9 613.1 1370.8 573 1392.3C505.4 1428.4 418.2 1421.9 356.7 1376.3C240.1 1289.5 254.6 1114.1 384.1 1045.6C399.8 1037.3 409.9 1033.8 439.5 1026.5C493.8 1013.1 525.5 998.2 561.5 969.3C603 936 634.4 890.9 653.5 837C667.6 797.1 669.5 792.1 675 780C700.1 724.8 746.8 676.4 801.8 648.7C870 614.2 940.4 605.6 1010.9 623.1C1093.5 643.6 1158.7 692.6 1198.8 764.5C1211.6 787.5 1218.5 805.2 1227 838C1243.3 900.2 1267.1 942.2 1308.9 982.2C1340.8 1012.8 1375.2 1032.3 1422 1046.5C1443.7 1053.1 1458.5 1059.4 1472.8 1068.2C1560 1121.5 1591.9 1232.1 1546.5 1323.5C1518.5 1379.8 1465.5 1418.7 1400.5 1430.6C1389.9 1432.5 1354.6 1433.3 1343 1432Z",
    "eyeLeft": { "cx": 920.5, "cy": 863.8 },
    "eyeRight": { "cx": 1059.5, "cy": 895.4 },
    "eyeAngleDeg": 13.5,
    "eyeWidth": 65.2,
    "eyeLength": 175.9,
    "orb": "M1400.7 846.5A190.6 190.6 0 1 0 1781.9 846.5A190.6 190.6 0 1 0 1400.7 846.5ZM1469.6 812.2L1482 863.1A18.8 18.8 0 0 0 1518.5 854.2L1506.1 803.3A18.8 18.8 0 0 0 1469.6 812.2ZM1545.5 794.3L1558.4 844.7A18.9 18.9 0 0 0 1595.1 835.3L1582.2 784.9A18.9 18.9 0 0 0 1545.5 794.3Z",
    "orbGradient": {
      "x1": 1457.9,
      "y1": 713.0,
      "x2": 1724.7,
      "y2": 979.9
    }
  },
  "wordmarkFont": {
    "family": "Poppins",
    "weight": 500,
    "letterSpacing": "-0.02em",
    "file": "assets/fonts/poppins-latin-500.woff2",
    "css": "assets/fonts/poppins.css",
    "fallback": "ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Helvetica, Arial, sans-serif"
  },
  "registry": "ghcr.io/hamza-at-nurturist/nurlings",
  "colors": {
    "themeLight": "#FCFCFC",
    "themeDark": "#141414",
    "splashLight": "#03091F",
    "splashDark": "#03091F",
    "iconBackground": "#03091F",
    "blob": "#FFFFFF",
    "orbGradient": ["#4FFFDB", "#6AAEF6", "#8F7AFB"]
  },
  "assets": {
    "markSvg": "assets/logo/nurlings-mark.svg",
    "markSmallSvg": "assets/logo/nurlings-mark-small.svg",
    "iconSvg": "assets/app-icon/nurlings-icon.svg",
    "logoSvg": "assets/logo/nurlings-logo.svg",
    "introSvg": "assets/logo/nurlings-intro.svg",
    "loaderSvg": "assets/logo/nurlings-loader.svg",
    "mark": "assets/logo/nurlings-mark.png",
    "wordmark": "assets/logo/nurlings-wordmark.svg",
    "wordmarkLight": "assets/logo/nurlings-wordmark-light.svg",
    "wordmarkDark": "assets/logo/nurlings-wordmark-dark.svg",
    "appIcon": "assets/app-icon/app-icon-1024.png",
    "appleIcon": "assets/app-icon/Nurlings.icon",
    "androidAdaptiveForeground": "assets/android/adaptive-foreground-1024.png",
    "androidAdaptiveBackground": "assets/android/adaptive-background-1024.png",
    "androidMonochrome": "assets/android/monochrome-1024.png",
    "androidNotification": "assets/android/notification-72.png",
    "splash": "assets/splash/splash-icon-1024.png",
    "favicon": "assets/favicon/favicon-128.png"
  },
  "updates": {
    "desktop": false,
    "mobileOta": false
  }
}
